export const READ = 'read';
export const WRITE = 'write';

export default [READ, WRITE];
